module.exports = __webpack_public_path__ + "img/motorized-wheelchair.9b36f770.png";